<template>
  <div>
    <div class="relative w-full header">
      <div class="header-title"></div>
      <div class="title">新闻资讯</div>
    </div>
    <div class="bg-white" style="min-height: calc(100vh - 520px)">
      <div class="max-w-screen-xl pt-8 m-auto overflow-hidden">
        <div class="float-left w-64">
          <a-menu
            :style="{ border: 0, width: '256px' }"
            v-model="selectedKeys"
            @click="categoryChange"
          >
            <a-menu-item class="text-center" :key="0">全部</a-menu-item>
            <a-menu-item
              class="text-center"
              v-for="item in news_categorys"
              :key="item.id"
              >{{ item.name }}</a-menu-item
            >
          </a-menu>
        </div>
        <div
          class="float-right pl-4"
          :style="{
            width: 'calc(100% - 256px)',
          }"
        >
          <a-list
            item-layout="horizontal"
            :data-source="newslist"
            :pagination="pagination"
          >
            <template slot="renderItem" slot-scope="item">
              <a-list-item>
                <router-link :to="`/news/${item.id}`" class="w-full">
                  <div class="w-full">
                    <div
                      class="float-left pr-4 text-left text-black truncate hover:text-blue-500"
                      style="width: calc(100% - 100px)"
                    >
                      {{ item.name }}
                    </div>
                    <div class="float-right text-gray-300" style="width: 100px">
                      {{ item.push_time.split(' ')[0] }}
                    </div>
                  </div>
                </router-link>
                <div style="float: none; clear: both"></div>
              </a-list-item>
            </template>
          </a-list>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { news_categorys, newss } from '@/api/news';
export default {
  data() {
    return {
      queryParam: { eq: { category_id: '' } },
      news_categorys: [],
      newslist: [],
      selectedKeys: [0],
      pagination: {
        onChange: (page) => {
          console.log(page);
          this.pagination.current = page;
          this.getNews();
        },
      },
      loading: true,
    };
  },
  mounted() {
    this.getNewsCategorys();
  },
  activated() {
    if (this.$route.query.category_id) {
      this.categoryChange(this.$route.query.category_id);
    } else {
      this.getNews();
    }
  },
  methods: {
    async getNewsCategorys() {
      console.log(
        await news_categorys({ qp: JSON.stringify({ eq: { review: 1 } }) })
      );
      this.news_categorys =
        (await news_categorys({ qp: JSON.stringify({ eq: { review: 1 } }) }))
          .data || [];
    },
    async getNews() {
      this.loading = true;
      let res = await newss({
        current: this.pagination.current,
        qp: JSON.stringify(this.queryParam),
      });
      this.newslist = res.data || [];
      this.pagination.total = res.total;
      this.loading = false;
    },
    categoryChange({ key }) {
      this.queryParam.eq = { category_id: key };
      this.pagination.current = 1;
      this.getNews();
    },
  },
};
</script>
<style lang="less" scoped>
.ant-list-item {
  display: flow-root;
}
.header {
  height: 400px;
  background-image: url(https://yldb.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-13/c6dfb5a2-3bd8-4d7f-8f64-e7c5e78ec3a5.jpg);
  background-clip: padding-box;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  background-blend-mode: normal;
  .header-title {
    width: 100%;
    height: 400px;
    background-image: linear-gradient(#3b82f6, #3b82f6);
    opacity: 0.4;
  }
}
.title {
  padding: 150px;
  line-height: 100px;
  font-size: 40px;
  color: #ffffff;
  position: absolute;
  text-align: center;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
}
.title:before {
  content: '';
  position: absolute;
  width: 1rem;
  height: 4px;
  top: 198px;
  left: 41%;
  background-color: #ffffff;
}
.title:after {
  content: '';
  position: absolute;
  width: 1rem;
  height: 4px;
  top: 198px;
  right: 41%;
  background-color: #ffffff;
}
</style>
